import styles from './Logo.module.scss';
import type { LogoProps } from './Logo.types';

export const Logo = ({ onClick }: LogoProps): JSX.Element => (
	<a className={styles.logo} href="#main" onClick={onClick}>
		Autoservis-Kraslice
	</a>
);
